import type { ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType } from './exploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType';

/**
 * 탐색 콘텐츠 기본 정보
 */
export type ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwo = {
  type: ExploreContentResponsePageAllOfThreeContentItemBasicInfoAllOfTwoType;
};
